import { useNotificationService } from '../../_services/NotificationService'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AlertBar, TextWrapper } from './styles'
import { IconX } from '@tabler/icons-react'
import moment from 'moment'
import { setScheduleNotifications } from '../../_redux/actions/notificationActions'

const ScheduleNotification = () => {
  const [isBannerVisible, setBannerVisible] = useState()
  const { scheduleNotification } = useNotificationService()
  const dispatch = useDispatch()

  const notificationContext = useSelector(
    (state) => state.notificationContextReducer.scheduleNotificationContext?.notifications
  )

  const latestSchedule =
    notificationContext?.length > 0 ? notificationContext[notificationContext?.length - 1] : null

  useEffect(() => {
    const callNotifyService = async () => {
      await scheduleNotification()
    }
    callNotifyService()
  }, [])

  const currentNotificationId =
    notificationContext && notificationContext.length !== 0
      ? moment(notificationContext[0]?.createdAt).valueOf().toString()
      : 0

  useEffect(() => {
    const isVisible = currentNotificationId !== 0 && currentNotificationId !== storedNotificationId
    dispatch(
      setScheduleNotifications({ notifications: notificationContext, isBannerVisible: isVisible })
    )
    setBannerVisible(isVisible)
  }, [currentNotificationId])

  const storedNotificationId = localStorage.getItem('notificationId')

  const onClose = () => {
    const id = moment(notificationContext[0]?.createdAt).valueOf().toString()
    localStorage.setItem('notificationId', id)
    dispatch(
      setScheduleNotifications({ notifications: notificationContext, isBannerVisible: false })
    )
    setBannerVisible(false)
  }

  return isBannerVisible &&
    notificationContext?.length !== undefined &&
    notificationContext?.length !== 0 ? (
    <AlertBar subtype={latestSchedule?.subType} id="schedule-notification">
      <TextWrapper>
        <b>{latestSchedule?.title}</b> - {latestSchedule?.message} &nbsp;
        <a href={latestSchedule?.ctaLinks} target="_blank" rel="noopener noreferrer">
          {latestSchedule?.ctaText}
        </a>
      </TextWrapper>
      <span onClick={onClose} aria-label="Close">
        <IconX size={24} />
      </span>
    </AlertBar>
  ) : null
}

export default ScheduleNotification
